import './hasPermission';
import './positive';



// WEBPACK FOOTER //
// ./src/directive/index.js